import { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

type Props = {
    children?: ReactNode;
    // Tests pass their own client so each render starts with an empty cache and its own
    // defaults. The app never sets it and shares the module-level client.
    client?: QueryClient;
};

const appQueryClient = new QueryClient();

const Provider = ({ children, client = appQueryClient }: Props) => {
    return (
        <QueryClientProvider client={client}>
            {children}
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
};

export default Provider;
